export const formatPhoneNumber = number => {
	number = number.replace(/\s/g, '').replace(/-/g, '').replace(/\(/g, '').replace(/\)/g, '');
	return `(${number.slice(0, 2)})${number.slice(2, 4)}-${number.slice(4, 6)}-${number.slice(6, 8)}-${number.slice(8)}`;
};
